import { Box, Button, Stack, Typography } from "@mui/material"
import ThinkingBubble from "components/UI/ThinkingBubble"
import { useAuthContext } from "contexts/AuthContext"
import useSound from "hooks/useSound"
import { useTranslation } from "react-i18next"
import { theme } from "themes/default/theme"
import { accountSetupAudios, getStartedSound } from "utils/sounds"
import { maxWidth600, minWidth1200 } from "themes/default/breakpoints"
import { LANGUAGES_ASSETS } from "../../../services/config"

const smashyImg = require("assets/img/auth/smashy-finish-setup.gif")
const smashorImg = require("assets/img/auth/smashor-finish-setup.gif")

export default function FinishTest({
  // accountType = 0,
  levelName = "",
  onClose = () => {},
}) {
  const { t, i18n } = useTranslation()
  const { isPlacementAssignation, audioSettings, accountType } =
    useAuthContext()
  const [playContinue] = useSound(getStartedSound, {
    volume: 0.5,
    soundEnabled: audioSettings?.enabledAudioEffects,
  })

  return (
    <Stack
      spacing={2}
      justifyContent={"center"}
      alignItems={"center"}
      sx={{
        minWidth: 600,
        minHeight: 180,
      }}
    >
      <Stack direction={"row"} spacing={3}>
        <Box
          component="img"
          src={accountType < 7 ? smashyImg : smashorImg}
          alt="Smash character"
          sx={{
            maxHeight: "60vh",
            minHeight: 100,
            width: "50vw",
            maxWidth: "50%",
            objectFit: "contain",
            [maxWidth600]: {
              maxWidth: "100%",
            },
            [minWidth1200]: {
              maxHeight: "30vh",
              maxWidth: "30vh",
            },
          }}
        />
        <Stack spacing={1} pt={5}>
          <ThinkingBubble
            arrowDirection="left"
            textAlign="center"
            paperSx={{
              overflow: "auto",
              maxHeight: "50vh",
              alignItems: "safe center",
            }}
            hideSoundButton
            sound={{
              uri: `${LANGUAGES_ASSETS}/sounds/createAccount/${
                i18n?.language || "en-US"
              }/${
                accountType < 7
                  ? "elementary"
                  : accountType < 13
                  ? "secondary"
                  : "university"
              }/${
                accountSetupAudios[
                  isPlacementAssignation
                    ? "placementTestCompleted"
                    : "diagnosticTestCompleted"
                ]
              }`,
              transcription: t(
                `${
                  isPlacementAssignation ? "placement" : "diagnostic"
                }_test_finished_message_${
                  accountType < 7
                    ? "elementary"
                    : accountType < 13
                    ? "secondary"
                    : "university"
                }`
              ),
              lang: i18n?.language || "en-US",
            }}
          >
            {
              /* !isPlacementAssignation && */ <>
                <Typography
                  variant="span"
                  textTransform={"capitalize"}
                  fontWeight={"bold"}
                  textAlign={"center"}
                >
                  {t(`your_starting_level`)}
                </Typography>
                <br />
              </>
            }
            <Typography
              variant="span"
              textTransform={"capitalize"}
              color="primary"
              fontWeight={"bold"}
              textAlign={"center"}
            >{`${t("Level")} ${levelName}`}</Typography>
            <br />
            {t(`your_missions_are_ready`)}
            {/* {isPlacementAssignation
              ? t(
                `placement_test_finished_message_${accountType < 7
                  ? "elementary"
                  : accountType < 13
                    ? "secondary"
                    : "university"
                }`,
                { level: levelName }
              )
              : t(
                `diagnostic_test_finished_message_${accountType < 7
                  ? "elementary"
                  : accountType < 13
                    ? "secondary"
                    : "university"
                }`,
                { level: levelName }
              )} */}
          </ThinkingBubble>
          <Box alignSelf={"center"}>
            <Button
              variant="contained"
              color="primary"
              disableElevation
              sx={{
                textTransform: "none",
                mr: 2,
                borderRadius: 5,
                minWidth: 100,
                backgroundColor: theme.palette.primary.main,
              }}
              onClick={() => {
                playContinue()
                onClose()
              }}
            >
              {t("continue")}
            </Button>
          </Box>
        </Stack>
      </Stack>
    </Stack>
  )
}
